export default "__VITE_ASSET__DYuvFnRc__"